import {
  imageUploader,
  indexconstituentUploader,
  indexDownload,
  indexmethadologyUploader,
  indexvalueUploader,
  indexyieldUploader,
} from "Common/utils/imageUploader";
import { showNotification } from "Common/utils/Notification";
import React, { useState } from "react";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";

// interface FileUploads {
//   factsheet?: File;
//   indexValues?: File;
//   constituentsFile?: File;
//   [key: string]: File | undefined;
// }

// interface FileUploadProps {
//   label: string;
//   name: keyof FileUploads;
//   files: FileUploads;
//   setFiles: React.Dispatch<React.SetStateAction<FileUploads>>;
//   errors: Record<string, string>;
//   setErrors: React.Dispatch<React.SetStateAction<Record<string, string>>>;
//   allowedTypes?: string[];
//   icon?: React.ReactNode;
// }

const FileUpload = ({
  label,
  id,
  name,
  files,
  setFiles,
  errors,
  setErrors,
  allowedTypes = [],
  getUploadStateDone = () => { },
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const mimeToExtension: Record<string, string> = {
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "text/csv": "csv",
    "application/pdf": "pdf",
  };
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const clearFileInput = (id: string) => {
    let fileElement = document.getElementById(id);
    if (fileElement) {
      (fileElement as HTMLInputElement).value = "";
    }
  };

  const { permission, user } = useSelector(selectProperties);
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      // Check for spaces in the filename and reject if any
      // if (file.name.includes(" ")) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     [name]: "File name must not contain spaces.",
      //   }));
      //   clearFileInput(name.toString());
      //   return;
      // }

      if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
        const allowedExtensions = allowedTypes
          .map((type) => mimeToExtension[type] || type.split("/").pop())
          .join(", ");

        setErrors((prev) => ({
          ...prev,
          [name]: `Invalid file type. Allowed: Sample.${allowedExtensions}`,
        }));
        clearFileInput(name.toString());
        return;
      }
      if (name === "constituentsFile") {
        setIsLoading(true);
        const res = await indexconstituentUploader(file, id);
        if (res?.status === "Success") {
          setIsLoading(false);
          showNotification("Uploaded successfully", "success");
          setFiles((prev) => ({
            ...prev,
            [name]: res.data.fileData,
          }));
          // setTimeout(() => {
          //   setFiles((prev) => ({
          //     ...prev,
          //     [name]: null,
          //   }));
          // }, 1000);
          clearFileInput(name.toString());
        }
      }
      if (name === "indexYieldFile") {
        setIsLoading(true);
        const res = await indexyieldUploader(file);
        if (res?.status === "Success") {
          setIsLoading(false);
          showNotification("Uploaded successfully", "success");
          setFiles((prev) => ({
            ...prev,
            [name]: res.data.fileData,
          }));
          // setTimeout(() => {
          //   setFiles((prev) => ({
          //     ...prev,
          //     [name]: null,
          //   }));
          // }, 2000);
          getUploadStateDone();
          clearFileInput(name.toString());
        }
      }
      if (name === "indexValues") {
        setIsLoading(true);
        const res = await indexvalueUploader(file, id);
        if (res?.status === "Success") {
          setIsLoading(false);
          showNotification("Uploaded successfully", "success");
          setFiles((prev) => ({
            ...prev,
            [name]: res.data.fileData,
          }));
          // setTimeout(() => {
          //   setFiles((prev) => ({
          //     ...prev,
          //     [name]: null,
          //   }));
          // }, 2000);
        }
        clearFileInput(name.toString());
      }

      // if (
      //   name === "englishMethodologyFile" ||
      //   name === "portugeseMethodologyFile"
      // ) {
      //   const res = await indexmethadologyUploader(file, id);
      //   if (res.status === "Success") {
      //     showNotification("Uploaded successfully", "success");
      //     setFiles((prev) => ({
      //       ...prev,
      //       [name]: res.data.fileData?.file_url,
      //     }));
      //   }
      //   clearFileInput(name.toString());
      // }
      // if (name === "factsheet") {
      //   const res = await imageUploader(file, user);
      //   if (res.status === "Success") {
      //     showNotification("Uploaded successfully", "success");
      //     setFiles((prev) => ({
      //       ...prev,
      //       [name]: res.data?.media,
      //     }));
      //   }
      //   clearFileInput(name.toString());
      // }
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  return (
    <div className="col-span-1">
      {label ? (
        <label className="block mb-1 font-medium">
          {label}
          {/* <span className="text-red-500">{" *"}</span> */}
        </label>
      ) : null}
      <button
        type="button"
        className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
        onClick={() => document.getElementById(name.toString())?.click()}
        disabled={isLoading?true:false}
      >
        {/* {icon && <span>{icon}</span>} */}
        <span>
          {/* {files[name] ? `📂 Change ${label}` : `⬆️ Click to Upload ${label}`} */}
          {isLoading ? "Uploading..." : (files[name] ? `📂 Change ${label}` : `⬆️ Click to Upload ${label}`)}
        </span>
      </button>

      <input
        id={name.toString()}
        type="file"
        className="hidden"
        onChange={handleFileChange}
      />

      {files[name] && (
        <p className="mt-1 text-sm text-gray-600">
          📄 {files[name]?.file_name}
        </p>
      )}

      {errors[name] && (
        <p className="mt-1 text-sm text-red-500">{errors[name]}</p>
      )}
    </div>
  );
};

export default FileUpload;
